module.exports = __webpack_public_path__ + "static/media/comment.14cee6f7.svg";